export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        campaignId: entity.campaignId || undefined,
        reusability: entity.reusability || undefined,
        expirationDate: entity.expirationDate || undefined,
        meta: entity.meta || {}
    };
};